import { render } from "./NavigationButtons.vue?vue&type=template&id=fcf13bae&scoped=true"
import script from "./NavigationButtons.vue?vue&type=script&lang=js"
export * from "./NavigationButtons.vue?vue&type=script&lang=js"

import "./NavigationButtons.vue?vue&type=style&index=0&id=fcf13bae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcf13bae"]])

export default __exports__